import { Dokument, UploadDokument } from "@/types";
import { DataService } from "./DataService";
import fileDownload from "js-file-download";

class DokumenteService extends DataService {
  protected readonly root: string;

  constructor(root: string) {
    super();
    this.root = root;
  }

  /**
   *@param id  object URI
   * @param dokument Dokument
   */
  public openDokument(
    id: number | string | null,
    dokument: Dokument,
    onDownloadProgress: (e: any) => void,
  ): Promise<void> {
    const props = { Accept: "application/octet-stream" };

    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.download<any>(
          this.root + `/${id}/dokumente/${dokument.id}`,
          {},
          props,
          onDownloadProgress,
        ),
      )
      .then((res: any) => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const blob = new Blob([res.data], { type: "image/png" });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(blob);
          return;
        }

        let filename = "download";
        const disposition = res.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        fileDownload(blob, filename);
      });
  }

  /**
   * @param id object Id
   * @param document UploadDokument
   */
  public uploadDokument(
    id: number | string | null,
    document: UploadDokument,
    onUploadProgress: (e: any) => void = (e: any): void => console.log(e),
  ): Promise<Dokument> {
    const formData = new FormData();
    formData.append("file", document.file);
    const docData = Object.assign({}, document);
    delete (docData as any)["file"];
    delete (docData as any)["_id"];

    formData.append("dokument", JSON.stringify(docData));

    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.upload<Dokument>(
          this.root + `/${id}/upload`,
          formData,
          onUploadProgress,
        ),
      );
  }
}

export default DokumenteService;
